<h1 mat-dialog-title>{{ data.title || 'Confirm Delete' }}</h1>
<div mat-dialog-content style="overflow: hidden">
  <p>{{ data.desc || 'Are you sure you want to delete this?' }}</p>
</div>
<div mat-dialog-actions style="margin-top: 20px;">
  <div fxLayout="row" fxLayoutAlign="flex-end center" fxLayoutGap="5px" style="width: 100%;">
    <button mat-button class="btn inline stroke" (click)="dialogRef.close()">
      {{ data.cancel || 'Cancel'  }}
    </button>
    <button mat-button cdkFocusInitial class="btn primary inline" (click)="dialogRef.close('confirm')">
      {{ data.confirmButton || 'OK'  }}
    </button>
  </div>
</div>
